import { useEffect, useState } from "react";
import { getCarouselDetails } from "../../utils/api";
import { imgUrl } from "../../utils/config";
import { Link } from "react-router-dom";
import "./css/tailwind.css";
import { logEvent } from "../../utils/eventTracker";
import banner1 from "../../icons/fire.webp";
import style from "../../screens/Questions/css/Questions.module.css";

const SeeMoreSpecialOffers = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getCarouselDetails();
      if (response.is_success && Array.isArray(response.message)) {
        const activeCampaigns = response.message.filter(
          (campaign) => campaign.status === "active" && campaign.priority === 2,
        );
        setData(activeCampaigns);
      } else {
        console.error("Unexpected response format:", response);
      }
    } catch (error) {
      console.error("Error fetching carousel data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const clickEventMetaData = (offer) => ({
    Event_Name: "See_More_Special_Offers_Click",
    Event_Sub_Name: "Special_Offer_Screen",
    Event_Type: "click",
    Event_Sub_Type: "full-page",
    user_id: localStorage.getItem("userId"),
    Event_MetaData: {
      offer_type: "Special_Offers",
      campaign_short_code: offer.campaign_short_code,
      campaign_name: offer.campaign_name,
      campaign_id: offer.id,
      creative_id: offer.creative_id,
      creative_name: offer.deal_name || "N/A",
      creative_url: null,
      redirection_url: offer.redirection_url,
    },
  });

  useEffect(() => {
    if (data.length > 0) {
      const impressionObject = {
        Event_Name: "Page_Open",
        Event_Sub_Name: "Special_Offer_Screen",
        Event_Type: "Screen_Impression",
        Event_Sub_Type: "list_view",
        user_id: localStorage.getItem("userId"),
        Event_MetaData: {
          ...data.reduce((specialOffer, offer) => {
            specialOffer[offer.id] = offer.campaign_name;
            return specialOffer;
          }, {}),
          offer_type: "Special_Offers",
        },
      };

      logEvent(impressionObject);
    }
  }, [data]);

  const rewardBannerPoints = () => {
    const currentPoints = Number(localStorage.getItem("userFanduPoints")) || 0;

    localStorage.setItem("userFanduPoints", currentPoints + 2);
  };

  if (loading) return <p>Loading offers...</p>;
  return (
    <div className="p-4 lg:mx-16 pb-16">
      <div className="mt-5 md:flex items-center gap-x-5 hidden md:block">
        <div className="h-0.5 w-full bg-gray-300 hidden md:block" />
        <h1 className="text-center font-semibold text-[#ED1A68] text-4xl lg:text-5xl w-full">
          Special Offers
        </h1>
        <div className="h-0.5 bg-gray-300 hidden md:block w-full" />
      </div>
      <h2 className="text-xl font-bold text-[#ED1A68]">Special Offers</h2>
      <p className="text-sm mt-1 md:hidden">
        Limited-time offers, unlimited happiness.
      </p>
      <div className="grid lg:grid-cols-2 gap-y-6 gap-x-9">
        {data
          ?.slice()
          .sort((a, b) => {
            const posA = a.position ?? Infinity;
            const posB = b.position ?? Infinity;
            return posA - posB;
          })
          .map((specialOffer, i) => (
            <Link
              to={specialOffer.redirection_url}
              key={specialOffer.id || i}
              className="no-underline"
              onClick={() => {
                logEvent(clickEventMetaData(specialOffer));
                rewardBannerPoints();
              }}
            >
              <img
                src={`${imgUrl}${specialOffer.image_name}`}
                alt={specialOffer.image_name}
                className="rounded-xl w-full"
              />
            </Link>
          ))}
      </div>
      <div className={style.hotDealsBottomRight}>
        <Link to="/hot-deals">
          <img src={banner1} alt="Hot Deals" className={style.hotDealsBtn} />
        </Link>
      </div>
    </div>
  );
};

export default SeeMoreSpecialOffers;
